import React from 'react';
import './EventCTASection.css'; // Make sure this CSS file is created and linked

const EventCTASection = () => {
  return (
    <section className="event-cta-section d-flex align-items-center justify-content-center text-center">
      <div className="container">
      <h2 className="event-heading mb-3 slide-up">
  Ready To Plan Your Next Event?
</h2>
<h3 className="event-subheading mb-4 slide-up">
  Lets Talk With Us Now.
</h3>
        <a href="#contact" className="btn btn-gradient px-4 py-2">
          Contact Us <span className="arrow ms-2">→</span>
        </a>
      </div>
    </section>
  );
};

export default EventCTASection;
